/** Deep clones serializable object */
export function deepClone<Type>(object: Type): Type {
  return JSON.parse(JSON.stringify(object));
}
